module.exports = __webpack_public_path__ + "img/c04_buildingtechadaptation_Normal_ua.953122b3.webp";